import { t } from '@lingui/core/macro';
import { Loader, Alert, UserAvatar } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { useSearchableMenuFuse, SearchableMenuMultiSelectList, SearchableMenuProvider, SearchableMenuSearchHeader, } from 'shared/domains/common-ui/SearchableMenu';
import { useGetUsers } from './useGetUsers';
export function UserField() {
    const { values, setFieldValue, submitForm } = useFormikContext();
    const { users, loading, error } = useGetUsers();
    const search = useSearchableMenuFuse(users, {
        keys: ['name'],
    });
    const handleSelectUser = (value) => {
        const added = values.value.includes(value);
        let newValues;
        if (added) {
            newValues = values.value.filter((existingValue) => existingValue !== value);
        }
        else {
            newValues = [...values.value, value];
        }
        setFieldValue('value', newValues);
        submitForm();
    };
    if (loading) {
        return <Loader />;
    }
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Error loading the users',
                comment: 'Metadata: Error message displayed when we could not load the company users',
            })}/>);
    }
    return (<SearchableMenuProvider {...search}>
      <SearchableMenuSearchHeader />
      <SearchableMenuMultiSelectList onSelect={(item) => handleSelectUser(item.id)} renderItem={({ name, email }) => <UserAvatar title={name} subtitle={email} size="sm"/>} selected={values.value}/>
    </SearchableMenuProvider>);
}
